module.exports = __webpack_public_path__ + "static/img/f0b0e0511be100bbb0c1e08d16a8f97d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv2.png
// module id = svTL
// module chunks = 1